import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger'; //logging middleware
import thunk from 'redux-thunk'; //async middleware
import theReducers from '../reducers';
import { autoRehydrate } from 'redux-persist';

// const middleWare = compose(applyMiddleware(thunk, createLogger()));
const middleWare = compose(applyMiddleware(thunk));
export default createStore(theReducers, middleWare, autoRehydrate());